
/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Mapeo de vencimientos para la tabla de edición
 */
export const DUE_MAPPING = [
  {
    label: '1er Vto.:',
    amount: 'first_due_amount',
    date: 'first_due_date',
    interest: 'first_interest',
  },
  {
    label: '2do Vto.:',
    amount: 'second_due_amount',
    date: 'second_due_date',
    interest: 'second_interest',
  },
  {
    label: '3er Vto.:',
    amount: 'third_due_amount',
    date: 'third_due_date',
    interest: 'third_interest',
  },
];

/**
 * Opciones de trimestres para el filtro
 */
export const QUARTER_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 1, label: '1 (Ene, Feb, Mar)' },
  { value: 2, label: '2 (Abr, May, Jun)' },
  { value: 3, label: '3 (Jul, Ago, Sep)' },
  { value: 4, label: '4 (Oct, Nov, Dic)' },
];

/**
 * Campos que deben actualizarse cuando cambian los montos
 */
export const AMOUNT_FIELDS_TO_UPDATE = [
  'first_due_amount',
  'second_due_amount', 
  'third_due_amount'
];

/**
 * Breakpoints para responsividad
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  orden: { width: { xs: '15%', md: '10%' } },
  suscriptores: { width: { xs: '20%', md: '10%' } },
  mes: { width: { xs: '10%', md: '10%' } },
  año: { width: { xs: '10%', md: '10%' } },
  cuotas: { width: { xs: '15%', md: '10%' } },
  importes: { minWidth: { xs: '25%', md: '10%' } },
  cancelado: { width: { xs: '15%', md: '10%' } },
  editar: { width: { xs: '10%', md: '10%' } },
  eliminar: { width: { xs: '10%', md: '10%' } },
  descargar: { width: { xs: '15%', md: '10%' } },
  acciones: { width: '15%' },
};

/**
 * Configuración de tamaños de fuente responsive
 */
export const FONT_SIZES = {
  header: { xs: '14px', sm: '15px' },
  tableHeader: { xs: '12px', md: '15px' },
  tableCell: { xs: '12px', md: '15px' },
  tableCellSmall: { xs: '11px', md: '15px' },
  dialogTitle: { xs: '16px', md: '18px' },
  dialogContent: { xs: '12px', md: '14px' },
  input: { xs: '10px', md: '12px' },
  pagination: { xs: '12px', md: '14px' },
};

/**
 * Configuración de padding responsive
 */
export const PADDING_CONFIG = {
  header: { xs: '10px', sm: '15px' },
  dialog: { xs: '8px', sm: '16px', md: '24px' },
  tableCell: { xs: '4px', md: '8px' },
  pagination: { xs: '15px 10px', sm: '15px' },
};

/**
 * Configuración de márgenes responsive
 */
export const MARGIN_CONFIG = {
  dialog: { xs: '8px', sm: '32px' },
  filter: { xs: 1, md: 0 },
  pagination: { xs: 2, sm: 0 },
};

/**
 * Año inicial para el selector de años
 */
export const START_YEAR = 1990;

/**
 * Tasa de interés por defecto (9% anual)
 */
export const DEFAULT_INTEREST_RATE = 0.09;

/**
 * Días en un mes (para cálculo de interés)
 */
export const DAYS_IN_MONTH = 30;